export default "__VITE_ASSET__6f5a82e4__"